import React, { useContext } from 'react';
import { Col, Row as BSRow } from 'react-bootstrap';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import NonRegisteredReportForm from '../comps/NonRegisteredReportForm';
import ReportChart from '../comps/ReportChart';
import TotalChart from '../comps/TotalChart';
import TotalReportForm from '../comps/TotalReportForm';
import { getDistsReportSum } from 'network/apis/ReportingApi';
import { useAdminSelector } from 'admin-app/redux/admin.store';
import { DashboardContext } from 'context/DashboardContext';
import useScreen from 'hooks/useScreen';

const Holder = styled.div`
	margin: 0 0.7rem;
`;

const Row = styled(BSRow)`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	border-top-right-radius: ${(props) => props.toprightradius ? props.toprightradius : '0'};

	&.bottom {
		border-top-left-radius: 26px;
		border-top-right-radius: 26px;
	}
`;

const DistributeTab = () => {
	const { currentTab } = useContext(DashboardContext);
	const filterState = useAdminSelector((store) => store.dashboardFilter);

	const { lessThan1200 } = useScreen();

	const { data: dists, isLoading } = useQuery(
		['get-dists-report', filterState.distsReportFilter],
		() => getDistsReportSum(filterState.distsReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'distribute'
		}
	);

	return (
		<Holder>
			<Row className='pt-3 pb-5'>
				<Col
					md={12}
					lg={12}
					xl={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'ps-5' : ''}`}
				>
					<TotalChart
						data={dists?.list?.data?.items}
						tabName='distribution'
						isLoading={isLoading}
					/>
				</Col>
				<Col
					md={12}
					lg={12}
					xl={7}
				>
					<Row>
						<TotalReportForm
							reportType='distribute'
							data={dists}
							isLoading={isLoading}
						/>
					</Row>
				</Col>
			</Row>
			{/* <Row className='mt-3 mb-5 pb-4 bottom'>				
				<Col md={7}>
					<Row toprightradius='26px'>
						<NonRegisteredReportForm title='گزارش عدم ثبت توزیع استانی' />
					</Row>
				</Col>
				<Col
					md={5}
					className={`d-flex justify-content-end ${!lessThan1200 ? 'pe-5' : ''}`}
				>
					<ReportChart reportType='distribute' />
				</Col>
			</Row> */}
		</Holder>
	);
};

export default DistributeTab;
